import type { BrowserPushAnalyticsResult } from "@/lib/analytics";
import type { WebPushEnableFailureStage } from "@/lib/web-push-browser";

interface ResolveWebPushEnableResultInput {
  errorName?: string;
  outcome: "success" | WebPushEnableFailureStage;
  permissionAfter: NotificationPermission | null;
  permissionBefore: NotificationPermission | null;
}

/** Maps browser permission and binding stages to the bounded analytics contract. */
export function resolveWebPushEnableResult({
  errorName,
  outcome,
  permissionAfter,
  permissionBefore,
}: ResolveWebPushEnableResultInput): BrowserPushAnalyticsResult {
  if (outcome === "session") return "session_error";
  if (outcome === "bind") return "bind_error";
  if (outcome === "subscribe") {
    if (permissionAfter === "denied") return "permission_denied";
    const permissionDismissed = [
      errorName === "NotAllowedError",
      permissionBefore === "default",
      permissionAfter === "default",
    ].every(Boolean);
    if (permissionDismissed) return "dismissed";
    return "subscribe_error";
  }
  if (permissionBefore === "granted") return "already_granted";
  if (permissionAfter === "granted") return "granted";
  return "success";
}
